import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Box from 'components/atoms/Layout/Box/Box';

const StyledCreditWalletPieChart = styled(Box)`
  display: flex;
  flex-direction: column;
  height: 100%;
  
  .CreditWalletPieChart {
    &-chart {
      height: 100%;
      overflow: hidden;
    }
    
    &-chart-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      height: 100%;
      width: 100%;
      
      aspect-ratio: 1;
    }

    &-center {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: absolute;

      .totalCount {
        line-height: ${props => props.theme.lineHeight('1f')};
      }
      .title {
        text-align: center;
      }
    }
    
    &-legend {
      flex-grow: 1;
      align-items: flex-start;
    }
  }

  // variants
  &.CreditWalletPieChart-half {
    .CreditWalletPieChart {
      &-center {
        height: 100%;
        justify-content: end;

        .Icon {
          font-size: ${props => props.theme.fontSize(24)};
        }

        .totalCount {
          margin-top: ${props => props.theme.layout(4)};
          margin-bottom: ${props => props.theme.layout(-3)};
          font-size: ${props => props.theme.fontSize(20)};
          line-height: ${props => props.theme.lineHeight('1f')};
          font-weight: 400;
        }

        .title {
          display: none;
        }
      }
    }
  }

  &.CreditWalletPieChart-showActiveShape {
    .CreditWalletPieChart {
      &-center {
        margin: 36%;
      }
    }
  }
  
  ${ComponentStyles}
`;

StyledCreditWalletPieChart.propTypes = {
  theme: PropTypes.object
};

export default StyledCreditWalletPieChart;
